import React, { useEffect, useState } from "react";
import { FaAngleUp } from "react-icons/fa6";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";

interface ISubMenu {
  index?: number;
  icon?: string;
  title: string;
  route: string;
  open?: boolean;
  subMenuItems?: ISubMenu[];
}
export const SubMenu: React.FC<ISubMenu> = ({
  index,
  icon,
  title,
  route,
  open,
  subMenuItems,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Проверяем, находится ли текущий путь в подменю
  const isActiveSubMenu = subMenuItems?.some(
    (subItem) => location.pathname === subItem.route
  ) || false;

  // Проверяем, активен ли сам пункт меню или его подменю
  const isActive = location.pathname === route || isActiveSubMenu;

  // Автоматически открываем подменю, если текущий путь находится в подменю
  useEffect(() => {
    if (isActiveSubMenu && open) {
      setIsMenuOpen(true);
    }
  }, [isActiveSubMenu, open]);

  const handleClick = (e: React.MouseEvent) => {
    // Если навбар свернут и есть подменю, переходим на первый элемент
    if (!open && subMenuItems && subMenuItems.length > 0) {
      e.preventDefault();
      navigate(subMenuItems[0].route);
      return;
    }
    // Иначе обычное поведение - открываем/закрываем подменю
    if (subMenuItems) {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  return (
    <li key={`submenu-${index}-${title}`}>
      {route?.length !== 0 ? (
        <Link to={route} onClick={(e) => !open && subMenuItems && subMenuItems.length > 0 && e.preventDefault()}>
          <button
            key={`menu-item-${title}-${index}`}
            className={`${isActive && "bg-mainColor bg-light-white text-white"} group w-full flex rounded-md p-2 cursor-pointer hover:bg-light-white items-center gap-x-4 mt-2 
            ${index === 0 && "bg-light-white"}  hover:bg-mainColor hover:text-white`}
            onClick={handleClick}
          >
            {icon && (
              <img
                src={icon}
                className={`${isActive && "brightness-0 invert"} block h-6 w-6 duration-200 group-hover:brightness-0 group-hover:invert ${icon.includes('history.svg') ? 'ml-0.5' : ''}`}
              />
            )}
            <span
              className={`${!open && "hidden"} whitespace-nowrap origin-left duration-200 font-normal text-sm`}
            >
              {title}
            </span>
            {subMenuItems && (
              <FaAngleUp
                className={`${!open && "hidden"} cursor-pointer ${!isMenuOpen && "rotate-180"}`}
              />
            )}
          </button>
        </Link>
      ) : (
        <button
          key={`menu-item-${title}-${index}`}
          className={`${isActive && "bg-mainColor bg-light-white text-white"} group w-full flex rounded-md p-2 cursor-pointer hover:bg-light-white items-center gap-x-4 mt-2 
        ${index === 0 && "bg-light-white"}  hover:bg-mainColor hover:text-white`}
          onClick={handleClick}
        >
          {icon && (
            <img
              src={icon}
              className={`${isActive && "brightness-0 invert"} block h-6 w-6 duration-200 group-hover:brightness-0 group-hover:invert ${icon.includes('history.svg') ? 'ml-0.5' : ''}`}
            />
          )}
          <span
            className={`${!open && "hidden"} whitespace-nowrap origin-left duration-200 font-normal text-sm`}
          >
            {title}
          </span>
          {subMenuItems && (
            <FaAngleUp
              className={`${!open && "hidden"} cursor-pointer ${!isMenuOpen && "rotate-180"}`}
            />
          )}
        </button>
      )}
      {subMenuItems && open && (
        <ul
          id={`dropdown-example-${index}-${title}`}
          className={`${!isMenuOpen && "hidden"} ml-4 py-2 space-y-2 duration-200`}
          key={`ul-sideMenu${index}-${title}`}
        >
          {subMenuItems?.map((subItemItem, subItemIndex) => (
            <li key={`submenu-item-${subItemItem.title}-${subItemIndex}`}>
              <Link to={subItemItem?.route}>
                <button
                  onClick={() => {}}
                  className={`${location.pathname === subItemItem?.route && "bg-mainColor bg-light-white text-white"} group w-full flex rounded-md p-2 cursor-pointer hover:bg-light-white items-center gap-x-4 mt-2 
            ${index === 0 && "bg-light-white"}  hover:bg-mainColor hover:text-white`}
                >
                  {subItemItem?.icon && (
                    <img
                      src={subItemItem?.icon}
                      className="block h-6 w-6 duration-200 group-hover:brightness-0 group-hover:invert"
                    />
                  )}
                  <span
                    className={`${!open && "hidden"} origin-left duration-200 font-normal text-sm`}
                  >
                    {subItemItem?.title}
                  </span>
                </button>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SubMenu;
